import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuReloadService {
  private reloadMenuSubject = new Subject<void>();
  reloadMenu$ = this.reloadMenuSubject.asObservable();

  triggerReload() {
    this.reloadMenuSubject.next();
  }
}
